<template>
    <div class="view view--password-email">
        <password-email />
    </div>
</template>

<script>
    import passwordEmail from '../../components/PasswordEmail.vue';

    export default {
        components: {
            passwordEmail
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/PasswordEmail.vue